import * as THREE from 'three'
import Experience from '../Experience.js'

// Campagne sous le terrain, affichée pendant la descente d'ouverture : vu
// d'altitude, le terrain (bords transparents) apparaîtrait comme une île
// dans le vide. Ce grand plan prolonge les champs jusqu'à l'horizon, où le
// brouillard l'efface. Il disparaît en fondu à l'approche du sol.
export default class Countryside {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene

        this.material = new THREE.MeshStandardMaterial({
            color: new THREE.Color('#8a9a58'),
            roughness: 1,
            metalness: 0,
            transparent: true,
            opacity: 0,
            depthWrite: false
        })

        this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(240, 240), this.material)
        this.mesh.rotation.x = -Math.PI / 2
        this.mesh.position.y = -0.02
        this.mesh.renderOrder = -1
        this.mesh.visible = false
        this.scene.add(this.mesh)
    }

    setOpacity(opacity) {
        this.material.opacity = opacity
        this.mesh.visible = opacity > 0.001
    }

    destroy() {
        this.scene.remove(this.mesh)
        this.mesh.geometry.dispose()
        this.material.dispose()
    }
}
